import React, { useEffect, useState } from 'react';
import { Button as ButtonMy } from '../../../../shared/ui/button';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import { InputField } from '../../../../shared/ui/input-field';
import { orderConfirmAddresSchema } from '../../lib/address-schema';
import { orderConfirmFormSections } from '../../lib/form-sections';
import { Address } from '../../../../types/interfaces';
import { MyModal } from '../../../../shared/ui/my-modal';

interface CartAddAddressModalProps {
  handleAddressSubmit: (data: Address) => void;
  setValue: any;
}

export function CartAddAddressModal({ handleAddressSubmit, setValue }: CartAddAddressModalProps) {
  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
  } = useForm({
    mode: 'onBlur',
    resolver: yupResolver(orderConfirmAddresSchema),
    shouldUnregister: false,
    defaultValues: {
      country: '',
      region: '',
      city: '',
      street: '',
      house: '',
      apartment: '',
      postcode: '',
    },
  });
  const [isModalOpen, setModalOpen] = useState(false);

  const submit = (data: Address) => {
    handleAddressSubmit({ ...data, id: new Date().getTime() });
    reset();
    setModalOpen(false);
  };

  useEffect(() => {
    return () => {
      reset({
        country: '',
        region: '',
        city: '',
        street: '',
        house: '',
        apartment: '',
        postcode: '',
      })
    }
  }, [])

  return (
    <>
      <button
        type="button"
        onClick={() => {
          setModalOpen(true);
          setValue('isAddAddressHandler', true);
        }}
        className="mt-5 flex-1 bg-transparent font-bold flex items-center gap-2 hover:text-[#e3282a] transition-colors"
      >
        Добавить адрес вручную
        <span className="w-[30px] h-[30px] rounded-full bg-red-600 text-white flex items-center justify-center text-lg leading-none">
          +
        </span>
      </button>
      <MyModal isOpen={isModalOpen} onClose={() => setModalOpen(false)}>
        <form onSubmit={handleSubmit(submit)}>
          <h2 className="text-xl font-bold mb-4">
            {orderConfirmFormSections.title}
          </h2>
          {orderConfirmFormSections.fields.map((field) => (
            <InputField
              key={field.id}
              inputName={field.inputName}
              label={field.label}
              errors={errors}
              register={register}
            />
          ))}
          <ButtonMy type="submit">Добавить</ButtonMy>
        </form>
      </MyModal>
    </>
  );
}
